<script setup>
import { onMounted, ref } from 'vue';
import FacilitiesMap from '@/components/facility/FacilitiesMap.vue';
import { useFacilityStore } from '@/stores/facility.js';
import DefaultLayout from "@/layouts/default.vue";

const facilityStore = useFacilityStore();
const loading = ref(false);
const error = ref(null);
const pageReady = ref(false);

onMounted(async () => {
  pageReady.value = true; // страница в DOM, можно безопасно монтировать карту
  loading.value = true;
  error.value = null;
  try {
    await facilityStore.loadFacilitiesCoordinates({ force: true });
  } catch (e) {
    console.error(e);
    error.value = 'Не удалось загрузить координаты объектов';
  } finally {
    loading.value = false;
  }
});

</script>

<template>
  <DefaultLayout>
    <div class="w-full h-screen p-2 md:p-4">
      <div class="w-full h-full rounded-xl overflow-hidden border border-surface-200 bg-surface-0">
        <div v-if="loading" class="p-4 text-sm text-color-secondary">Загрузка карты…</div>
        <div v-else-if="error" class="p-4 text-sm text-red-600">{{ error }}</div>
        <FacilitiesMap
            v-else-if="pageReady"
            :points="facilityStore.facilitiesCoordinates || []"
        />
      </div>
    </div>
  </DefaultLayout>
</template>